import { render, staticRenderFns } from "./TipoEnderecoSelect.vue?vue&type=template&id=19f4236a&"
import script from "./TipoEnderecoSelect.vue?vue&type=script&lang=js&"
export * from "./TipoEnderecoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports